// 头部只放一个按钮，按钮写「点一下会发生什么」，不写当前状态（状态由页面上的数字表达）。
// 关注和持仓是两条互不混用的线：行情页只管关注，核算页只管持仓。
//
//   行情页 market      未关注 → 加入关注 / 已关注 → 取消关注
//   核算页 workspace   已转正 → 查看持仓 / 其余 → 不显示按钮
//   核算页 holding     不显示按钮
//
// 2026-09-02 起持仓进出全自动（口径①）：核算跑通即转正、清仓即移出。
// 「加入持有标的」和「移出持仓」两个手动按钮因此一起下线——自动进来的东西
// 也会自动出去，留着手动入口只会和自动行为打架。
// 两个后端接口和 client.js 里的调用保留，恢复步骤见
// docs/sdd/astock-agent-v07-single-asset-agent-behavior/parked-session-management.md。
export function resolveSingleAssetTrackingAction({
  viewType,
  hasTrackedHolding = false,
  watching = false,
  busy = false,
  showingRetainedWorkspace = false,
}) {
  if (showingRetainedWorkspace) {
    return hasTrackedHolding
      ? { kind: "view_holding", label: "查看持仓", disabled: false }
      : null;
  }

  let action = null;
  if (viewType === "market") {
    action = { kind: "toggle_watch", label: watching ? "取消关注" : "加入关注", disabled: false };
  } else if (viewType === "workspace" && hasTrackedHolding) {
    action = { kind: "view_holding", label: "查看持仓", disabled: false };
  }

  return action && busy
    ? { ...action, label: "正在更新…", disabled: true }
    : action;
}
